import React from "react";
import { useStep } from "../../../context/stepContext";
import { useChair } from "../../../context/ChairContext";
import { Step } from "./Step";
import { Loader } from "../../Loader";
import { useGetChairConfiguratorInfo } from "../../../api/hooks/useChairs";
import { plausibleEvent } from "../../../utilities/helper";
import { ChairInfoButton } from "../ChairInfoButton";

const AccessoryOption = ({ name, price, articleID }) => {
    const id = useChair((state) => state.chair.id);
    const extra = useChair((state) => state.chair.extra);
    const setChair = useChair((state) => state.setChair);

    const handleClick = (event) => {
        event.stopPropagation();
        setChair({
            id: id,
            extra: { name: name, price: price, articleID: articleID },
        });
        plausibleEvent("accessory-selected", name);
    };

    return (
        <li className={"accessory-option"} onClick={handleClick}>
            <div className={"accessory-name"}>{name}</div>
            <input type={"radio"} checked={extra?.name === name} onChange={handleClick} />
        </li>
    );
};

export const AccessoryStep = () => {
    const { setStep } = useStep();
    const id = useChair((state) => state.chair.id);

    const chairConfigInfoQuery = useGetChairConfiguratorInfo({ id: id });
    const chairInfo = chairConfigInfoQuery.isSuccess ? (chairConfigInfoQuery.data.chairEntries[0] ?? null) : null;

    return (
        <div className={"step accessory-step"}>
            <button
                className={"button back-button icon-button"}
                onClick={() => {
                    setStep(Step.OVERVIEW);
                }}
            >
                Zurück
            </button>
            <ChairInfoButton />
            <h2 className={"heading"}>Wählen Sie Ihr Zubehör</h2>
            {chairConfigInfoQuery.isLoading ? (
                <Loader />
            ) : (
                <>
                    <ul className={"accessory-options"}>
                        {chairInfo?.parent.accessory?.map((accessory) => {
                            return (
                                <AccessoryOption
                                    key={accessory.accessoryName[0].articleID}
                                    name={accessory.accessoryName[0].title}
                                    price={accessory.accessoryCost}
                                    articleID={accessory.accessoryName[0].articleID}
                                />
                            );
                        })}
                    </ul>
                </>
            )}
        </div>
    );
};
